import { cn } from "../utils"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  nonAnimated?: boolean
}

function Skeleton({ className, nonAnimated, ...props }: Props) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-primary/10",
        nonAnimated && "animate-none",
        className,
      )}
      {...props}
    />
  )
}
export { Skeleton }
